import { getAuthenticatedRequestInit } from './utils';
import { getApiHost } from '../utils/hosts';

export async function TrimSaveAs(
	token: string,
	mediaId: number,
	start: string,
	end: string,
	newTitle: string | null,
) {
	try {
		await fetch(`${getApiHost()}/v2/greenroom/trim/save-as/${mediaId}`, {
			method: 'POST',
			body: JSON.stringify({
				title: newTitle,
				startTimecode: start,
				endTimecode: end,
			}),
			...getAuthenticatedRequestInit(token),
		});
	} catch (e) {
		return console.error(e);
	}
}

export async function TrimSaveOver(token: string, mediaId: number, start: string, end: string) {
	try {
		await fetch(`${getApiHost()}/v2/greenroom/trim/save-over/${mediaId}`, {
			method: 'PUT',
			body: JSON.stringify({
				startTimecode: start,
				endTimecode: end,
			}),
			...getAuthenticatedRequestInit(token),
		});
	} catch (e) {
		return console.error(e);
	}
}
